import JobDetailBody from "./jobDetailBody"

export default JobDetailBody
